import React  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useDispatch } from "react-redux";
import { closeConfigDialog } from '../state/files/actions';


const ConfigModal = ({
    open,
   // setOpenConfig,
    value,
    setConfigData,
    configFile,
    setConfigFile,
    handleConfigFormData,
    isDefaultModal,
    setIsDefaultModal,
    isDefaultSerialModal,
    setIsDefaultSerialModal,
    fileType,
    controllersList
}) => {
    
    const dispatch = useDispatch();
 
    // Function to set values of the Form Fields
    const changeHandler = (e) => {  
        setConfigData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };

    // Function to set the file value
    const changeFileHandler = (event) => {
        setConfigFile(event.target.files[0]);
    };

    // Function to handle the close of Form popup
    const handleClose = () => {
        setConfigFile('');
        setIsDefaultModal(false);
        setIsDefaultSerialModal(false);
        setConfigData({
            version : '',
            releaseNotes:'',
            serialNumber:'',
            controllerId: controllersList[0]?.id,
        });
        dispatch(closeConfigDialog());
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open} >
            <DialogTitle>{fileType === '1' ? 'Upload Config File' : 'Upload Default Config File' }</DialogTitle>
            <DialogContent dividers> 
                { (!isDefaultModal || isDefaultSerialModal) && 
                <TextField  
                    margin="dense"
                    id="serialNumber"
                    label="Genset 
                    Serial Number"
                    fullWidth
                    name="serialNumber"
                   // sx={{paddingBottom:3}}
                    value={value.serialNumber}
                    onChange={changeHandler}
                    error={value.serialNumber === ""}
                    helperText={value.serialNumber === "" ? "Required Field!" : " "}
                />
                }
                <FormControl fullWidth 
                    sx={{  paddingBottom:2 }}
                >
                    <InputLabel id="demo-simple-select-standard-label">Controller</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        label="Products"
                        sx={{ "&:focus": {
                            backgroundColor: "#ffffff"
                          } 
                        }}
                        value={value.controllerId}
                        onChange={changeHandler}
                        name="controllerId"
                    >
                        {controllersList?.map((row, i) => (
                            <MenuItem value={row.id}>{row.controller_name}</MenuItem>
                        ))}
                        {/* <MenuItem value={1}>RDC2.4</MenuItem>
                        <MenuItem value={2}>DC2.4 </MenuItem>
                        <MenuItem value={3}>RDC2-DC2</MenuItem>
                        <MenuItem value={4}>RDC-DC </MenuItem>
                        <MenuItem value={5}>VSC </MenuItem>
                        <MenuItem value={6}>VSC.4 </MenuItem> */}
                    </Select>
                </FormControl>
                <TextField 
                    label="Release Notes" 
                    id="releaseNotes" 
                    name="releaseNotes"
                    multiline
                    rows={4}
                    fullWidth
                    sx={{paddingBottom:2}}
                    value={value.releaseNotes}
                    onChange={changeHandler}
                    error={value.releaseNotes === ""}
                    helperText={value.releaseNotes === "" ? "Required Field!" : " "}
              />
                <InputLabel id="file-select-label">Upload File</InputLabel>
                <Input 
                type="file" 
                name="uploadFile"
                accept=".bin"
                fullWidth
                onChange={changeFileHandler} 
                error={configFile === "" }             
                >Upload File</Input>
                { configFile === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleConfigFormData}
                >Submit</Button>
                <Button  variant="contained"
            size="medium"
            color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfigModal
